import { render, staticRenderFns } from "./FacebookSocial.vue?vue&type=template&id=09d9f265&scoped=true&"
import script from "./FacebookSocial.vue?vue&type=script&lang=js&"
export * from "./FacebookSocial.vue?vue&type=script&lang=js&"
import style0 from "./FacebookSocial.vue?vue&type=style&index=0&id=09d9f265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9f265",
  null
  
)

export default component.exports